import type { ConversationKeywordDTO } from '@conversed/rest/src/contracts/conversation-keywords/conversation-keywords.dto';
import { mainActions } from '@store/reducers/mainHandler';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useMainSelector } from '../../useMainSelector';

export const useConversationKeywords = () => {
  const {
    conversationKeywords: { keywords, selectedKeyword },
  } = useMainSelector();
  const dispatch = useDispatch();

  const setSelectedConversationKeyword = useCallback(
    (keyword: ConversationKeywordDTO) => {
      dispatch(mainActions.setSelectedConversationKeyword(keyword));
    },
    [dispatch],
  );

  return {
    keywords,
    selectedKeyword,
    setSelectedConversationKeyword,
  };
};
